import React, { useEffect, useState, useRef } from "react";
import './Analytics.css'
import Select from 'react-select'
import axios from 'axios'
import DatePicker from 'react-datepicker'
import AnalyticsDownArrow from './../../../../images/analyticsdownarrow.png'
import FilterIcon from './../../../../images/filtericon.png'
import LineGraphIcon from './../../../../images/linegraphicon.png'
import LineGraphIconGrey from './../../../../images/linegraphicongrey.png'
import BarGraphIcon from './../../../../images/bargraphicon.png'
import BarGraphIconWhite from './../../../../images/bargraphiconwhite.png'
import DropDownIcon from './../../../../images/dropdownicon.png'
import UpStockArrow from './../../../../images/upstockarrow.png'
import DownStockArrow from './../../../../images/downstockarrow.png'
import NoAnalytics from './../../../../images/noanalytics.png'
import PaymentInfoBtn from './../../../../images/paymentinfobtn.png'
import calendericon from './../../../../images/calendericon.png'
import httpConfig from "../AxiosConfig/httpConfig";
import {axiosInstance} from "../AxiosConfig/AxiosInstance";
import Cookies from "universal-cookie";
import { Trans, useTranslation} from 'react-i18next'
import i18next from "i18next"
import {useNavigate} from "react-router-dom";
import "react-datepicker/dist/react-datepicker.css";
import styled from "styled-components"
import ArtistDots1 from './../../../../images/artistdots1.png'
import EArtistPage from './../../../../images/EartistPage.png'
import ArtistStepTarget from './../../../../images/artiststeptarget.png'

function LoadingAnalytics() {
    
    const [viewoption,setViewOption] = useState({ value: 'Stream', label: 'Stream' })
    const [byoption,setByOption] = useState({value: 'DSP', label: 'DSP'})
    const [statsArray,setStatsArray] = useState([]);
    const [statDatesArray,setDatesArray] = useState([]);
    const [value,setValue] = useState();
    const [loading,setLoading] = useState(true);
    const [legend,setLegend] = useState([]);
    const datetoday = new Date();
    const [emptyGraphState,setEmptyGraphState] = useState(true);

    const [dateFilter,setDateFilter] = useState("Last 7 days")

    const [emptyAnalytics,setEmptyAnalytics] = useState(true)

    const [currentStatTotal,setCurrentStatTotal] = useState(0)
    const [lastStatTotal,setLastStatTotal] = useState(0)
 
    const [ygraphpoints,setYGraphPoints] = useState([])
    const [myValue,setMyValue] = useState([])
    const [graphOption,setGraphOption] = useState(0)
    const [filterOption,setFilterOption] = useState(0) 
    const [hintValue, setHintValue] = useState(undefined); 
    const [hint, setHint] = useState(undefined); 
    const navigate = useNavigate();


    const [refreshGraph, setRefreshGraph] = useState(0); 

    const [xgraphpoints,setXGraphPoints] = useState([[]]); 
    const [thisweekTotals,setThisWeekTotals] = useState(new Array())
    const [lastweekTotals,setLastWeekTotals] = useState(new Array()) 

    const [percentChanges,setPercentChanges] = useState([])
    const [statsListMap, setStatsListMap] = useState(new Map())
    const [statsListArray, setStatsListArray] = useState([]) 
    const [statslist,setStatsList] = useState([]) 
    const [checkarray,setCheckArray] = useState(0)
 
    const [asset,setAsset] = useState("")
    const [assetId,setAssetId] = useState("")
    const [product,setProduct] = useState("") 
    const [productId,setProductId] = useState("") 
    const [dsp,setdsp] = useState("")
    const [dspid,setdspid] = useState("")
    const [territory,setTerritory] = useState("")
    const [territoryId,setTerritoryId] = useState("")
    const [daterange,setDateRange] = useState(-1)

    const [customstartdate,setCustomStartDate] = useState(new Date())
    const [customenddate,setCustomEndDate] = useState(new Date())

    const [assetOptions,setAssetOptions] = useState([])
    const [AssetSearch,setAssetSearch] = useState([])
    const [enableAssetSearch,setEnableAssetSearch] = useState(false)
    const [productOptions,setProductOptions] = useState([])
    const [ProductSearch,setProductSearch] = useState([])
    const [enableProductSearch,setEnableProductSearch] = useState(false)

    const [territorySearch,setTerritorySearch] = useState([])
    const [enableTerritorySave,setEnableTerritorySave] = useState(false)
    const [DSPSearch,setDSPSearch] = useState([])
    const [enableDSPSave,setEnableDSPSave] = useState(false)

    const isHoveringOverLine = useRef({});
    const [hoveredPoint, setHoveredPoint] = useState([]);
    
    const [colors,setColors] = useState(["#ff7f0e","#ffbb78","#1f77b4","#2ca02c","#aec7e8","#2ca02c"])

    const {t, i18n } = useTranslation();
    const cookies = new Cookies(null ,{ path: '/' });

    const [dimensions, setDimensions] = useState({ 
        height: window.innerHeight,
        width: window.innerWidth 
      })

    const handleResize = () => {
        setDimensions({
        width: window.innerWidth,
        height: window.innerHeight,
        });
    }

    useEffect(() => {
      window.addEventListener("resize", handleResize, false);
    }, []);
   
    const viewOptions = [{ value: 'Stream', label: 'Stream' },
    { value: 'Download', label: 'Download' },
    { value: 'Spotify Insights', label: 'Spotify Insights' },
    { value:'Apple Music Insights',  label:'Apple Music Insights'  },
    { value:'Deezer Insights',  label:'Deezer Insights'  },
    { value:'Amazon Insights',  label:'Amazon Insights'  },
    { value:'Pandora Insights',  label:'Pandora Insights'  },
    { value:'Line Music Insights',  label:'Line Music Insights'  },
    { value:'Tiktok Insights',  label:'Tiktok Insights'  },
    { value:'Playlists',  label:'Playlists'  },
    { value:'Custom reports',  label:'Custom reports'  }]

    
    const jpviewOptions = [{ value: 'Stream', label: 'ストリーム数' },
                    { value: 'Download', label: 'ダウンロード数' },
                    { value: 'Spotify Insights', label: 'Spotify インサイト' },
                    { value:'Apple Music Insights',  label:'Apple Music インサイト'  },
                    { value:'Deezer Insights',  label:'Deezer インサイト'  },
                    { value:'Amazon Insights',  label:'Amazon インサイト'  },
                    { value:'Pandora Insights',  label:'Pandora インサイト'  },
                    { value:'Line Music Insights',  label:'Line Music  インサイト'  },
                    { value:'Tiktok Insights',  label:'TikTiok  インサイト'  },
                    { value:'Playlists',  label:'プレイリスト'  },
                    { value:'Custom reports',  label:'カスタムレポート'  }]

    const byOptions = [ {value: 'DSP', label: 'DSP'},
                        {value: 'Territory', label: 'Territory'},
                        {value: 'Asset', label: 'Asset'},
                      ]

    const jpbyOptions = [ {value: 'DSP', label: 'DSP別'},
                      {value: 'Territory', label: '地域別'},
                      {value: 'Asset', label: 'レーベル別'},
                    ]

    const changeViewHandler = value => {
                        setViewOption(value)
                        setRefreshGraph(Math.random())
                    }
                
    const changeByHandler = value => {
                        setByOption(value)
                        setRefreshGraph(Math.random())
                    }
                    const colourStyles = {
                        control: styles => ({ ...styles,  borderColor: '#636468',
                        backgroundColor:'#182833',
                        width: '10em',
                        height: '2.5em',
                        borderRadius:'8px',
                        color:'rgba(255, 255, 255, 1)',
                        marginLeft:'0.5em'
                       }),
                        option: (styles, { data, isDisabled, isFocused, isSelected }) => {
                          return {
                            ...styles,
                            backgroundColor:'#18191F' ,
                            color:'rgba(255, 255, 255, 1)',
                            cursor: isDisabled ? 'not-allowed' : 'default',
                            marginTop:'-0.3em',
                            marginBottom:'-0.3em',
                            borderRadius:'3px'
                          };
                        },
                        input: (styles) => ( {...styles , 
                                                FontFamily:'ClashGrotesk-Variable,sans-serif',
                                                FontSize:'1rem',
                                                FontWeight: 'medium',
                                                LineHeight: '150%',
                                                LetterSpacing: '0%',
                                                color:'rgba(255, 255, 255, 1)'}),
                        singleValue : (styles) => ({ ...styles, 
                                                        color:'rgba(255, 255, 255, 1)',
                                                        FontFamily:'ClashGrotesk-Variable,sans-serif',
                                                        FontSize:'1rem',
                                                        FontWeight: 'medium',
                                                        LineHeight: '150%',
                                                        LetterSpacing: '0%'
                                                        }),
                        menuList: (base) => ({ ...base,
                                                        "::-webkit-scrollbar": {
                                                            width: "0px",
                                                            height: "0px",
                                                        },
                                                        "::-webkit-scrollbar-track": {
                                                            background: "#f1f1f1"
                                                        },
                                                        "::-webkit-scrollbar-thumb": {
                                                            background: "#888"
                                                        },
                                                        "::-webkit-scrollbar-thumb:hover": {
                                                            background: "#555"
                                                            }
                                                          })
                };


    return (
    <div>
        <div style={{display:'flex',flexDirection:'row',alignItems:'center',justifyContent:'space-between',alignSelf:'flex-start',width:'90%',marginLeft:'2.5em'}}>
                <div style={{display:'flex',flexDirection:'row',alignItems:'center',marginTop:'1.5em',marginLeft:'0.7em'}}>
                    <div className="ViewHeader">{t('View')}</div>
                    {
                        cookies.get('lang') === 'en' &&
                        <Select options={viewOptions} value={viewoption} onChange={changeViewHandler} 
                        components={{
                            IndicatorSeparator: () => null
                        }}
                        styles={
                            colourStyles
                        }
                         defaultValue={{ label: "Streams", value: "Streams"}}
                        /> 
                    }

                    {
                        cookies.get('lang') === 'jp' &&
                        <Select options={jpviewOptions} value={viewoption} onChange={changeViewHandler} 
                        components={{
                            IndicatorSeparator: () => null
                        }}
                        styles={
                            colourStyles
                        }
                         defaultValue={{ label: "ストリーム数", value: "Streams"}}
                        /> 
                    }
                  

                    <div className="ViewHeader" style={{marginLeft:'2em',marginRight:'1em'}}>{t('By')}</div>
                    {
                        cookies.get('lang') === 'en' &&
                        <Select options={byOptions} value={byoption} onChange={changeByHandler} 
                        components={{
                            IndicatorSeparator: () => null
                        }}
                        styles={ 
                            colourStyles
                        }
                         defaultValue={{ label: "DSP別", value: "DSP"}}
                        /> 
                    }

                    {
                        cookies.get('lang') === 'jp' &&
                        <Select options={jpbyOptions} value={byoption} onChange={changeByHandler} 
                        components={{
                            IndicatorSeparator: () => null
                        }}
                        styles={ 
                            colourStyles
                        }
                         defaultValue={{ label: "DSP別", value: "DSP"}}
                        /> 
                    }
                    
                </div>

                {/* <div className="CustomReportBtn">
                {t('Createcustomreport')}
                </div> */}
            </div>
            <div style={{width:'90%',height:'0.5px',backgroundColor:'#595959',marginTop:'2em',marginBottom:'2em',marginLeft:'2.5em',alignSelf:'center'}}/>
            <div style={{display:'flex',flexDirection:'row',width:'100%',justifyContent:'space-between'}}>
            <div style={{display:'flex',flexDirection:'row',marginLeft:'2.5em',alignItems:'center',flexWrap:'wrap',width:'80%',alignItems:'center'}}>
                    
                            <div style={{flex:'dispay',flexDirection:'column'}}>
                                <div className="FilterBtn" style={{cursor:'pointer'}} onClick={()=>setFilterOption(1)}>
                                    {
                                       asset.length===0 &&
                                       <div className="FilterBtnHeading">{t('Asset')}</div>
                                    }
                                    {
                                        asset.length!==0 &&
                                        <div className="FilterBtnHeading">{asset}</div>
                                    }
                                  
                                    <img src={DropDownIcon} alt="Drop down icon" className="DropdownIcon"/>
                                    
                                    </div>
                                {
                                    filterOption===1 &&
                                    <div>
                                        <div className="blocker" onClick={()=>{setFilterOption(0);}}>'</div>
                                        <div style={{backgroundColor:'#2A333D',borderRadius:'4px',width:'20.875em',marginTop:'-0.5em',position:'absolute',border:'1px solid rgba(255,255,255,50%)',zIndex:'2'}}> 
                                        <div className="FilterBtnHeading" style={{paddingTop:'1em',paddingLeft:'1em',marginBottom:'1em'}}>{t('Asset')}</div>
                                        <div style={{position:'relative'}}>
                                            <input
                                                value={asset}
                                                onChange={e =>{setAsset(e.target.value);setEnableAssetSearch(false)} } 
                                                // style={{
                                                //     borderColor: '#636468',
                                                //     backgroundColor:'#18191F',
                                                //     width: '17em',
                                                //     height: '2.5em',
                                                //     borderRadius:'8px',
                                                //     color:'rgba(255, 255, 255, 1)',
                                                //     marginLeft:'0.5em'
                                                // }}
                                                className="FilterSearch"
                                                type='text'
                                                /> 
                                                <div style={{position:'absolute',top:'3em',left:'0.9em',backgroundColor:'rgba(0,0,0,90%)',width:'19.275em',borderRadius:'4px',border:'1px solid rgba(255,255,255,50%)',zIndex:'2'}}>
                                                {AssetSearch.length!==0 &&
                                                    AssetSearch.map((product)=>{
                                                          return (
                                                              <div className="FilterSearchItem" onClick={()=>{setAsset(product.name);setAssetId(product.id);setAssetSearch([]);setEnableAssetSearch(true)}}>
                                                                  {product.name} 
                                                                  </div>
                                                          )
                                                      })
                                                  }
                                          </div>
                                      </div>
                                      <div style={{display:'flex',flexDirection:'row',width:'95%',justifyContent:'flex-end',alignItems:'center',paddingTop:'1em',paddingBottom:'1em'}}>
                                                <div className="CancelFilterBtn"  onClick={()=>{setFilterOption(0);setAsset("");setAssetId("")}}>
                                                Clear
                                                </div>
                                   
                                                {
                                                    asset.length===0 && 
                                                    <div className="CancelFilterBtn"  onClick={()=>{setFilterOption(0);setAsset("");setAssetId("")}}>
                                                    Cancel
                                                    </div>
                                                }

                                                {
                                                    asset.length!==0  && !enableAssetSearch &&
                                                    <div className="CancelFilterBtn"  onClick={()=>{setFilterOption(0);setAsset("");setAssetId("")}}>
                                                    Cancel
                                                    </div>
                                                } 
                                                
                                                {
                                                    asset.length!==0  && enableAssetSearch &&
                                                    <div className="CancelFilterBtn"  onClick={()=>{setFilterOption(0);}}>
                                                    Cancel
                                                    </div>
                                                }   
                                                  
                                                

                                                {
                                                    !enableAssetSearch &&
                                                    <div className="SaveFilterBtn" style={{backgroundColor:'#821D41',color:'#8D9297',cursor:'auto'}}>
                                                     Save
                                                    </div>
                                                }
                                                {
                                                    enableAssetSearch &&
                                                    <div className="SaveFilterBtn" onClick={()=>{setFilterOption(0); setRefreshGraph(Math.random())}}>
                                                    <div className="HoverOverlay" style={{top:'0em'}}/>
                                                     Save
                                                    </div>
                                                }
                                           
                                      
                                    </div>
                                        </div>
                                    </div>
                                }
                            
                            </div>

                            <div style={{flex:'dispay',flexDirection:'column'}}>
                                <div className="FilterBtn" style={{cursor:'pointer'}} onClick={()=>setFilterOption(2)}>
                                    {
                                       product.length===0 &&
                                        <div className="FilterBtnHeading">{t('Product')}</div>
                                    }
                                    {
                                        product.length!==0 &&
                                        <div className="FilterBtnHeading">{product}</div>
                                    }
                                    <img src={DropDownIcon} alt="Drop down icon" className="DropdownIcon"/>
                                </div>
                                {
                                    filterOption===2 &&
                                    <div>
                                    <div className="blocker" onClick={()=>{setFilterOption(0);}}>'</div>
                                    <div style={{backgroundColor:'#2A333D',borderRadius:'4px',width:'20.875em',marginTop:'-0.5em',position:'absolute',border:'1px solid rgba(255,255,255,50%)',zIndex:'2'}}> 
                                    <div className="FilterBtnHeading" style={{paddingTop:'1em',paddingLeft:'1em',marginBottom:'1em'}}>{t('Product')}</div>
                                        <div style={{position:'relative'}}>
                                            <input
                                                value={product}
                                                onChange={e => {setProduct(e.target.value);setEnableProductSearch(false)}} 
                                                // style={{
                                                //     borderColor: '#636468',
                                                //     backgroundColor:'#18191F',
                                                //     width: '17em',
                                                //     height: '2.5em',
                                                //     borderRadius:'8px',
                                                //     color:'rgba(255, 255, 255, 1)',
                                                //     marginLeft:'0.5em'
                                                // }}
                                                className="FilterSearch"
                                                placeholder="Search Products"
                                                type='text'
                                                />
                                            <div style={{position:'absolute',top:'3em',left:'0.9em',backgroundColor:'rgba(0,0,0,90%)',width:'19.275em',borderRadius:'4px',border:'1px solid rgba(255,255,255,50%)',zIndex:'2'}}>
                                                  {ProductSearch.length!==0 &&
                                                    ProductSearch.map((product)=>{
                                                            return (
                                                                <div className="FilterSearchItem" onClick={()=>{setProduct(product.name);setProductId(product.id);setProductSearch([]);setEnableProductSearch(true)}}>
                                                                    {product.name} 
                                                                    </div>
                                                            )
                                                        })
                                                    }
                                            </div>
                                        </div>
                                        <div style={{display:'flex',flexDirection:'row',width:'95%',justifyContent:'flex-end',alignItems:'center',paddingTop:'1em',paddingBottom:'1em'}}>
                                                <div className="CancelFilterBtn"  onClick={()=>{setFilterOption(0);setProduct("");setProductId("")}}>
                                                Clear
                                                </div>
                                   
                                                {
                                                    product.length===0 && 
                                                    <div className="CancelFilterBtn"  onClick={()=>{setFilterOption(0);setProduct("");setProductId("")}}>
                                                    Cancel
                                                    </div>
                                                }

                                                {
                                                    product.length!==0  && !enableProductSearch &&
                                                    <div className="CancelFilterBtn"  onClick={()=>{setFilterOption(0);setProduct("");setProductId("")}}>
                                                    Cancel
                                                    </div>
                                                } 
                                                
                                                {
                                                    product.length!==0  && enableProductSearch &&
                                                    <div className="CancelFilterBtn"  onClick={()=>{setFilterOption(0);}}>
                                                    Cancel
                                                    </div>
                                                }   
                                                  
                                                

                                                {
                                                    !enableProductSearch &&
                                                    <div className="SaveFilterBtn" style={{backgroundColor:'#821D41',color:'#8D9297',cursor:'auto'}}>
                                                     Save
                                                    </div>
                                                }
                                                {
                                                    enableProductSearch &&
                                                    <div className="SaveFilterBtn" onClick={()=>{setFilterOption(0); setRefreshGraph(Math.random())}}>
                                                    <div className="HoverOverlay" style={{top:'0em'}}/>
                                                     Save
                                                    </div>
                                                }
                                           
                                      
                                    </div>
                                    </div>
                                    </div>
                                }
                            </div>

                            <div style={{flex:'dispay',flexDirection:'column'}}>
                                <div className="FilterBtn" style={{cursor:'pointer'}} onClick={()=>setFilterOption(3)}>
                                    {
                                        dsp.length===0 &&
                                        <div className="FilterBtnHeading">{t('Dsp')}</div>
                                    }
                                    {
                                        dsp.length!==0 &&
                                        <div className="FilterBtnHeading">{dsp}</div>
                                    }
                                    <img src={DropDownIcon} alt="Drop down icon" className="DropdownIcon"/>
                                </div>
                                {
                                    filterOption===3 &&
                                    <div>
                                    <div className="blocker" onClick={()=>{setFilterOption(0);}}>'</div>
                                    <div style={{backgroundColor:'#2A333D',borderRadius:'4px',width:'20.875em',marginTop:'-0.5em',position:'absolute',border:'1px solid rgba(255,255,255,50%)'}}> 
                                    <div className="FilterBtnHeading" style={{paddingTop:'1em',paddingLeft:'1em',marginBottom:'1em'}}>{t('Dsp')}</div>
                                    <div style={{position:'relative'}}>
                                    <input
                                        value={dsp}
                                        onChange={e => {setdsp(e.target.value);setEnableDSPSave(false)}} 
                                        // style={{
                                        //     borderColor: '#636468',
                                        //     backgroundColor:'#18191F',
                                        //     width: '17em',
                                        //     height: '2.5em',
                                        //     borderRadius:'8px',
                                        //     color:'rgba(255, 255, 255, 1)',
                                        //     marginLeft:'0.5em'
                                        // }}
                                        className="FilterSearch"
                                        placeholder="Search DSP"
                                        type='text'
                                        />
                                        <div style={{position:'absolute',top:'3em',left:'0.9em',backgroundColor:'rgba(0,0,0,90%)',width:'19.275em',borderRadius:'4px',border:'1px solid rgba(255,255,255,50%)',zIndex:'2'}}>
                                                {DSPSearch.length!==0 &&
                                                   DSPSearch.map((dsp)=>{
                                                        return (
                                                            <div className="FilterSearchItem" onClick={()=>{setdsp(dsp.name);setdspid(dsp.id);setDSPSearch([]);setEnableDSPSave(true)}}>
                                                                {dsp.name} 
                                                                </div>
                                                        )
                                                    })
                                                }
                                        </div>
                                     </div>
                                     <div style={{display:'flex',flexDirection:'row',width:'95%',justifyContent:'flex-end',alignItems:'center',paddingTop:'1em',paddingBottom:'1em'}}>
                                                <div className="CancelFilterBtn"  onClick={()=>{setFilterOption(0);setdsp("");setdspid("")}}>
                                                Clear
                                                </div>
                                   
                                                {
                                                    dsp.length===0 && 
                                                    <div className="CancelFilterBtn"  onClick={()=>{setFilterOption(0);setdsp("");setdspid("")}}>
                                                    Cancel
                                                    </div>
                                                }

                                                {
                                                    dsp.length!==0  && !enableDSPSave &&
                                                    <div className="CancelFilterBtn"  onClick={()=>{setFilterOption(0);setdsp("");setdspid("")}}>
                                                    Cancel
                                                    </div>
                                                } 
                                                
                                                {
                                                    dsp.length!==0  && enableDSPSave &&
                                                    <div className="CancelFilterBtn"  onClick={()=>{setFilterOption(0);}}>
                                                    Cancel
                                                    </div>
                                                }   
                                                  
                                                

                                                {
                                                    !enableDSPSave &&
                                                    <div className="SaveFilterBtn" style={{backgroundColor:'#821D41',color:'#8D9297',cursor:'auto'}}>
                                                     Save
                                                    </div>
                                                }
                                                {
                                                    enableDSPSave &&
                                                    <div className="SaveFilterBtn" onClick={()=>{setFilterOption(0); setRefreshGraph(Math.random())}}>
                                                    <div className="HoverOverlay" style={{top:'0em'}}/>
                                                     Save
                                                    </div>
                                                }
                                           
                                      
                                    </div>
                                    </div>
                                    </div>
                                }
                            </div>

                            <div style={{flex:'dispay',flexDirection:'column'}}>
                                <div className="FilterBtn" style={{cursor:'pointer'}} onClick={()=>setFilterOption(4)}>
                                    {
                                        territory.length===0 &&
                                        <div className="FilterBtnHeading">{t('Territory')}</div>
                                    }
                                    {
                                        territory.length!==0 &&
                                        <div className="FilterBtnHeading">{territory}</div>
                                    }
                                   
                                    <img src={DropDownIcon} alt="Drop down icon" className="DropdownIcon"/>
                                </div>

                                {
                                    filterOption===4 &&
                                    <div>
                                    <div className="blocker" onClick={()=>{setFilterOption(0);}}>'</div>
                                    <div style={{backgroundColor:'#2A333D',borderRadius:'4px',width:'20.875em',marginTop:'-0.5em',position:'absolute',border:'1px solid rgba(255,255,255,50%)'}}> 
                                    <div className="FilterBtnHeading" style={{paddingTop:'1em',paddingLeft:'1em',marginBottom:'1em'}}>{t('Territory')}</div>
                                    <div style={{position:'relative'}}>
                                    <input
                                        value={territory}
                                        onChange={e => {setTerritory(e.target.value);setEnableTerritorySave(false)}} 
                                     
                                        className="FilterSearch"
                                        placeholder="Search territories"
                                        type='text'
                                        />
                                        <div style={{position:'absolute',top:'3em',left:'0.9em',backgroundColor:'rgba(0,0,0,90%)',width:'19.275em',borderRadius:'4px',border:'1px solid rgba(255,255,255,50%)',zIndex:'2'}}>
                                                {territorySearch.length!==0 &&
                                                    territorySearch.map((territory)=>{
                                                        return (
                                                            <div className="FilterSearchItem" onClick={()=>{setTerritory(territory.name);setTerritoryId(territory.id);setTerritorySearch([]);setEnableTerritorySave(true)}}>
                                                                {territory.name} ({territory.id})
                                                                </div>
                                                        )
                                                    })
                                                }
                                        </div>
                                    </div>
                                            
                                   

                                    <div style={{display:'flex',flexDirection:'row',width:'95%',justifyContent:'flex-end',alignItems:'center',paddingTop:'1em',paddingBottom:'1em'}}>
                                                <div className="CancelFilterBtn"  onClick={()=>{setFilterOption(0);setTerritory("");setTerritoryId("")}}>
                                                Clear
                                                </div>
                                   
                                                {
                                                territory.length===0 && 
                                                <div className="CancelFilterBtn"  onClick={()=>{setFilterOption(0);setTerritory("");setTerritoryId("")}}>
                                                Cancel
                                                </div>
                                                }

                                                {
                                                territory.length!==0 &&
                                                <div className="CancelFilterBtn"  onClick={()=>{setFilterOption(0);}}>
                                                Cancel
                                                </div>
                                                }

                                                {
                                                    !enableTerritorySave &&
                                                    <div className="SaveFilterBtn" style={{backgroundColor:'#821D41',color:'#8D9297',cursor:'auto'}}>
                                                     Save
                                                    </div>
                                                }
                                                {
                                                    enableTerritorySave &&
                                                    <div className="SaveFilterBtn" onClick={()=>{setFilterOption(0); setRefreshGraph(Math.random())}}>
                                                    <div className="HoverOverlay" style={{top:'0em'}}/>
                                                     Save
                                                    </div>
                                                }
                                           
                                       
                                    </div>
                                    </div>
                                    </div>
                                }
                            </div>

                            <div style={{flex:'dispay',flexDirection:'column'}}>
                                {
                                    filterOption===5 &&<div className="blocker" onClick={()=>{setFilterOption(0);}} style={{cursor:'default'}}>'</div>
                                }
                            
                                <div className="FilterBtn" onClick={()=>setFilterOption(5)} style={{cursor:'pointer',position:'relative'}}>
                                    <div className="FilterBtnHeading">{dateFilter}</div>
                                    <img src={DropDownIcon} alt="Drop down icon" className="DropdownIcon"/>
                                   
                                </div>

                                {
                                    filterOption===5 &&
                                    <div style={{position:'absolute',top:'14.5em'}}>
                                   
                                    <div className={daterange===-1?"DateBox" :"DateBoxOpen"} style={{backgroundColor:'#2A333D',borderRadius:'4px',marginTop:'-0.5em',position:'absolute',display:'flex',flexDirection:'column',border:'1px solid rgba(255,255,255,50%)'}}> 
                                        <div style={{display:'flex',flexDirection:'row'}}>
                                        <div style={{marginTop:'1em',marginBottom:'1em',width:'20.875em'}}>
                                            <div className="DateRangeH1" style={{marginLeft:'0.88em',marginBottom:'0.88em'}}>Date Range</div>
                                            <div className="DateObject" onClick={()=>setDateRange(0)}>
                                                <div className="DateBtnHeading"  >{t('Weeks')}</div>
                                                <img src={PaymentInfoBtn} style={{width:'0.5em',height:'0.875em'}}/>
                                            </div>

                                            <div className="DateObject" onClick={()=>setDateRange(1)}>
                                                <div className="DateBtnHeading"  >{t('Monthssearch')}</div>
                                                <img src={PaymentInfoBtn} style={{width:'0.5em',height:'0.875em'}}/>
                                            </div>

                                            <div className="DateObject" onClick={()=>setDateRange(2)}>
                                                <div className="DateBtnHeading"  >{t('Years')}</div>
                                                <img src={PaymentInfoBtn} style={{width:'0.5em',height:'0.875em'}}/>
                                            </div>

                                            <div className="DateObject" onClick={()=>setDateRange(3)}>
                                                <div className="DateBtnHeading"  >{t('Customdaterange')}</div>
                                                <img src={PaymentInfoBtn} style={{width:'0.5em',height:'0.875em'}}/>
                                            </div>
                                           
                                        </div>

                                        {
                                            daterange === 0 &&
                                            <div className="DateRightContainer">
                                                <div className="DateDetailsHeading" >This Week</div>
                                                <div className="DateDetailsHeading" >Last Week</div>
                                                <div className="DateDetailsHeading" >Last 7 days</div>
                                                <div className="DateDetailsHeading" >Last 14 days</div>
                                                <div className="DateDetailsHeading" >Last 30 days</div>
                                            </div>
                                        }

                                      

                                        {
                                            daterange === 2 &&
                                            <div className="DateRightContainer">
                                                <div className="DateDetailsHeading" >This Year</div>
                                                <div className="DateDetailsHeading" >Last Year</div>
                                                <div className="DateDetailsHeading" >2022</div>
                                                <div className="DateDetailsHeading" >2021</div>
                                            </div>
                                        }

                                       
                                         </div>

                                        {
                                            daterange !== -1 &&
                                            <div className="DateBottom">
                                                <div className="CancelFilterBtn"  onClick={()=>{setFilterOption(0);setDateRange(-1)}}>
                                                Cancel
                                                </div>

                                                <div className="SaveFilterBtn">
                                                Save
                                                </div>
                                            </div>
                                        }
                                      
                                    </div>
                                   
                                    </div>
                                }

                               
                            </div> 

                            <div className="ClearAllTxt" style={{cursor:'pointer',marginTop:'-0.5em'}} onClick={()=>{
                            setAsset("");
                            setProduct("");
                            setdsp("");
                            setTerritory("");
                            setRefreshGraph(Math.random());
                            }}>
                            {t('Clearall')}
                            </div>
                    </div>

                   
            </div>
                    <div className="GraphTrendContainer">
                        <div className="GraphTrendHeader" style={{color:'transparent'}}>{t('Streamsofassetandproducts')}</div>
                        <div style={{display:'flex',flexDirection:'row',alignItems:'center',marginLeft:'2.5em'}}>
                            <div className="GraphTrendAmount" style={{color:'transparent'}}>{currentStatTotal.toLocaleString("en-US")}</div>
                            {Math.round(((currentStatTotal - lastStatTotal)/ lastStatTotal)*10000)/100 <0 &&
                            <div style={{display:'flex',flexDirection:'row',alignItems:'center'}}>
                                <div className="GraphTrendArrow"/>
                                <div className="GraphTrendPerc" style={{color:'transparent'}}>{Math.round(((currentStatTotal - lastStatTotal)/ lastStatTotal)*10000)/100}%</div>
                            </div>
                            }

                            {Math.round(((currentStatTotal - lastStatTotal)/ lastStatTotal)*10000)/100 > 0 &&
                            <div style={{display:'flex',flexDirection:'row',alignItems:'center'}}>
                                <div style={{height:'0.5em',width:'0.6em',marginLeft:'0.5em'}}/>
                                <div className="GraphTrendPerc" style={{color:'transparent'}}>{Math.round(((currentStatTotal - lastStatTotal)/ lastStatTotal)*10000)/100}%</div>
                            </div>
                            }
                        
                        
                        </div>

                    
                        
                    </div>


                    <div className="GraphContainer">

                    <div style={{display:'flex',flexDirection:'row',marginBottom:'1em',justifyContent:'space-between',backgroundColor:'rgba(255,255,255,8%)',paddingTop:'1.5em',paddingBottom:'1.5em',paddingRight:'1.5em',paddingLeft:'2.5em',borderTopLeftRadius:'8px',borderTopRightRadius:'8px'}}>
                    <div className="GraphTitle" style={{color:'transparent'}}>{byoption.value}</div>

                    <div style={{display:'flex',flexDirection:'row',width:'10%'}}>
                                
                            

                            
                                {
                                    graphOption===0 && 
                                    <div className="GraphSlider">
                                    <div className="GraphSliderOption" style={{borderTopRightRadius:'0px',borderBottomRightRadius:'0px',backgroundColor:'#6D33C9',cursor:'pointer'}}>
                                                <img src={LineGraphIcon} style={{height:'1.25em',width:'1.25em'}}/>
                                            </div>

                                            <div className="GraphSliderOption" style={{borderTopLeftRadius:'0px',borderBottomLeftRadius:'0px',cursor:'pointer'}} onClick={()=>setGraphOption(1)}>
                                                <img src={BarGraphIcon} style={{height:'1.25em',width:'1.25em'}}/>
                                            </div>
                                    </div>
                                }

                                {
                                    graphOption===1 && 
                                    <div className="GraphSlider">
                                    <div className="GraphSliderOption" style={{borderTopRightRadius:'0px',borderBottomRightRadius:'0px',cursor:'pointer'}} onClick={()=>setGraphOption(0)}>
                                                <img src={LineGraphIconGrey} style={{height:'1.25em',width:'1.25em'}}/>
                                            </div>

                                            <div className="GraphSliderOption" style={{borderTopLeftRadius:'0px',borderBottomLeftRadius:'0px',backgroundColor:'#6D33C9',cursor:'pointer'}}>
                                                <img src={BarGraphIconWhite} style={{height:'1.25em',width:'1.25em'}}/>
                                            </div>
                                    </div>
                                }
                            
                            </div>
                    </div>

                    <div style={{display:'flex',flexDirection:'row',justifyContent:'center',marginBottom:'2em',flexWrap:'wrap',marginLeft:'1.5em'}}>
                               

                                {
                                    statsArray.map((dist,index)=>{
                                        // console.log(dist.name)
                                        return (
                                        <div style={{display:'flex',flexDirection:'row',alignItems:'center'}}>
                                            <div style={{width:'0.6em',height:'0.6em',borderRadius:'100px',backgroundColor:colors[index%colors.length]}}/>
                                            <div className="LegendItem">
                                                {dist.name}
                                            </div>
                                        </div>
                                        )
                                        
                                    })
                                }
                                
                    </div>

            

                            {
                                graphOption===0 &&
                                <div style={{height:'582px',width:'100%'}}/>
                                   
                               
                            } 

                            {
                                graphOption === 1 &&
                                <div style={{height:'582px',width:'100%'}}/>
                            }

                    </div>

                    <div style={{display:'flex',width:'90%',height:'20em',flexDirection:'column',marginLeft:'2.5em',marginTop:'1.5em',backgroundImage:'linear-gradient(174.92deg, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.04%, rgba(204, 204, 255, 0.04) 91.48%)',borderRadius:'8px'}}/>
                           
                          
                 
    </div>
    )
  
}

export default LoadingAnalytics;